import { put,call, takeLatest, select, delay } from 'redux-saga/effects';
import axios from 'axios';
import config from '../config';
import Cookies from 'js-cookie';

//Action
import { loadingSet } from '../action/uiAction';

var packageJson = require('../../package.json');

function* mailSendCheck(action) {
  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('type', 'check');
    params.append('version', packageJson.version);
    return axios.post(config.apiUri + "member/mailSendApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  if (res) {
    action.callback(res.data);
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
}

function* mailSendText(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('type', 'send');
    params.append('category', payload.category);
    params.append('text', payload.text);
    params.append('version', packageJson.version);
    return axios.post(config.apiUri + "member/mailSendApi.php", params, {
      timeout: 5000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.send === true) {
      yield delay(600);
      yield put({ type: 'MAIL_GROUP_LIST_DATETIME_INIT'});
      if (action.payload.category !== 'approach-pending') {
        yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 3000, comment: '送信しました'} });
      }
      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* mailSendPhoto(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    var params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('type', 'send');
    params.append('category', payload.category);
    params.append('photoBase64', payload.photoBase64);
    return axios.post(config.apiUri + "member/mailSendApi.php", params, {
      timeout: 60000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.send === true) {
      yield delay(600);
      yield put({ type: 'MAIL_GROUP_LIST_DATETIME_INIT'});
      if (action.payload.category !== 'photo-pending') {
        yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 3000, comment: '送信しました'} });
      }
      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* mailSendVoice(action) {
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const fd = new FormData();
    fd.append('ULIC', Cookies.get('ULIC'));
    fd.append('ULPC', Cookies.get('ULPC'));
    fd.append('pic', payload.pic);
    fd.append('type', 'send');
    fd.append('category', payload.category);
    fd.append('file', payload.wav, 'voice.wav');
    return axios.post(config.apiUri + "member/mailSendApi.php", fd, {
      headers: {
        'content-type': 'multipart/form-data',
      },
      timeout: 60000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);

  if (res) {
    if (res.data.send === true) {
      yield delay(600);
      yield put({ type: 'MAIL_GROUP_LIST_DATETIME_INIT'});
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'success', duration: 3000, comment: '送信しました'} });

      action.callback(res.data);
    }
    else {
      yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: res.data.comment} });
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}

function* mailTalkListGet(action) {
  const state = yield select();
  yield put(loadingSet(true));
  const {res, err} = yield call(function (payload) {
    const params = new URLSearchParams();
    params.append('ULIC', Cookies.get('ULIC'));
    params.append('ULPC', Cookies.get('ULPC'));
    params.append('pic', payload.pic);
    params.append('page', payload.page);
    params.append('version', packageJson.version);
    return axios.post(config.apiUri + "member/mailTalkListApi.php", params, {
      timeout: 10000
    })
    .then((res) => {
      return {res};
    })
    .catch((err) => {
      return {err};
    })
  }, action.payload);
  yield delay(100);
  if (res) {
    if (res.data.bool) {
      action.callback(res.data);
      if (res.data.confirmed) {
        yield put({
          type: "MAIL_GROUP_ITEM_SET",
          payload: {
            type: 'confirmed',
            pic: action.payload.pic,
          },
        });
      }

      if (state.notification.mailUnconfirmed > 0) {
        yield put({type: 'NOTIFICATION_GET'});
      }
    }
  }
  if (err) {
    yield put({ type: 'SNACK_SET', payload: {visible: true, severity: 'error', duration: 5000, comment: config.apiErrComment} });
  }
  yield put(loadingSet(false));
}


const saga = [
  takeLatest('MAIL_SEND_CHECK', mailSendCheck),
  takeLatest('MAIL_SEND_TEXT', mailSendText),
  takeLatest('MAIL_SEND_PHOTO', mailSendPhoto),
  takeLatest('MAIL_SEND_VOICE', mailSendVoice),
  takeLatest('MAIL_TALK_LIST_GET', mailTalkListGet),
];

export default saga;
